<template lang="pug">
  ion-col
    ion-card
      ion-item
        ion-avatar( slot="start" )
          img(:src="require('../assets/img/user.png')" )
        ion-label
          h2
            b Solicitud: 
            | # {{ this.returnNumberID(cardInfo.id) }}
          h2 
            b Cliente: 
            | {{ cardInfo.cliente }}
          h2 
            b Solicitante: 
            | {{ cardInfo.UsrSol }}

          //- p dolor sit amet
      ion-card-content

        p.mt-10 
          b Área de maniobra: 
          | {{ cardInfo.AreaManiobra }}
        p.mt-10 
          b Fecha propuesta: 
          | {{ getDateFormat(cardInfo.fecha,"D") }}
        p.mt-10 
          b Hora propuesta: 
          | {{ getDateFormat(cardInfo.hora,"H") }}

        p
          ion-chip
            ion-icon( :src="require('../assets/svg/barbell-outline.svg')" )
            ion-label Peso: {{ cardInfo.peso}}

          ion-chip
            ion-icon(:src="require('../assets/svg/arrow-down-circle-outline.svg')" )
            ion-label Altura:  {{ cardInfo.altura}}
          
          ion-chip()
            ion-icon(:src="require('../assets/svg/radio-outline.svg')" )
            ion-label Radio: {{ cardInfo.radio}}
          
      ion-row(no-padding)
        ion-col( v-if=" readOnly == 0 " )
          ion-button(  expand="full"  size="small" @click="openModal(cardInfo,cardInfo.id)" ) Ver &nbsp;&nbsp;
        ion-col(text-right)
          ion-button(  expand="full"  size="small" :color="colorStatus" ) {{ getStatusAdmin(cardInfo.status) }} 
</template>
<style lang="scss" scoped >
  ion-avatar{width: 30%; height: 30%;}
  ion-datetime{text-align: right;}
	.btn-flat{
		width: 100%;
		min-height: 40px;
		font-size: 15px;
		background: transparent;
	}
  .mt-10{
    margin-top:10px;
  }
  .ml-15{
    margin-left: -15px;
  }
</style>
<script>
import firebase from "../config"
import {func} from '../func.js'
const { db } = firebase;
import Modal from './Modal'
let dt = require('dateformat');
export default {
  name: "SimpleCardAdmin",
  props: ["cardInfo","readOnly"],
  data() {
    return {
      colorStatus: "danger",
    }
  },
  methods: {
    returnNumberID(_string){
      return func.returnID(_string);
    },
    getDateFormat($d,$f) {
      // let now = new Date($d);
      // let f = ($f == "D") ? dt(now, "yyyy, mmmm d"): dt(now, "h:MM TT") ;
      return func.getDateFormat($d,$f,"yyyy, mmmm d");
    },

    getStatusAdmin(_status){
      let _default        = "Por revisión";
      let _resolveResponse = null;
      if( _status.length > 2 ){
        _resolveResponse = _status[2];
        this.colorStatus     = "warning";
      }else{
        _resolveResponse = _default;
      }
      
      return _resolveResponse;
    },
    openModal($cardInfo, $id) {
      let arr = ["En revsión",4,"leída"];
      db.collection('todos').doc(this.cardInfo.id).update({status:arr})
        .then ( () => console.log("update . . .") );
      return this.$ionic.modalController
        .create({
          component: Modal,
          componentProps: {
            data: {
              content: 'New Content',
              datos: $cardInfo,
              stringId: $id
            },
            propsData: {
              title: 'Card admin modal ',
              ModalModify:1
            },
          },
        })
      .then(m => {
        this.currentModal = m;
        m.present()
      })
    },
    resolveColor ($c) {
      let _color = "default"
      switch ($c) {
        case "Alto":
          _color = "success"
          break;
        case "Medio":
          _color = "warning"
          break;
        case "Bajo":
          _color = "danger"
          break;
      
        default:
          break;
      }
      return _color
    }
  },
};
</script>